export default __webpack_public_path__ + "static/media/PFD-Tostador.04ee7f96.png";